import React from 'react';
import { Icon, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import logo from '../../images/logo/logo-white.png';
import fullLogo from '../../images/logo/logo-full-black.png';
import ModalHeader from '../drive/ModalHeader';
import LoadingComponent from "../common/LoadingComponent";
import { app } from '../../services/feathers.service';
import '../staticweb/styles.css';
import './styles.css';

class EmailVerified extends React.Component {
    constructor(props) {
        super(props);
        this.state = { width: window.innerWidth, desktopLoggedIn: false, showLoginFallback: false };
        this.handleResize = this.handleResize.bind(this);
        this.fallbackTimer = null;
        this.handleAutoLoginComplete = this.handleAutoLoginComplete.bind(this);
        this.goToLogin = this.goToLogin.bind(this);
        this.goToUpdatePassword = this.goToUpdatePassword.bind(this);
    }

    handleResize() {
        this.setState({ width: window.innerWidth });
    }

    goToLogin(e) {
        e.preventDefault();
        this.props.history.push('/login');
    }

    goToUpdatePassword(e) {
        e.preventDefault();
        this.props.history.push('/forgotpassword');
    }

    handleAutoLoginComplete(data) {
        const { userid } = this.props.match.params;
        if (data.userId === userid) {
            clearTimeout(this.fallbackTimer);
            this.setState({ desktopLoggedIn: true });
        }
    }

    async componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        app.service('accountusers').on('autoLoginComplete', this.handleAutoLoginComplete);

        this.fallbackTimer = setTimeout(() => {
            if (!this.state.desktopLoggedIn) {
                this.setState({ showLoginFallback: true });
            }
        }, 10000);

        const { userid, otp } = this.props.match.params;
        await dispatch.registerAccount.verifyEmail({ userid, otp });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        app.service('accountusers').off('autoLoginComplete', this.handleAutoLoginComplete);
        clearTimeout(this.fallbackTimer);
    }

    render() {
        const { loading, verificationStatus, version } = this.props;
        const { desktopLoggedIn, showLoginFallback } = this.state;
        const isMobile = this.state.width <= 1024;

        let nextStepContent;
        if (desktopLoggedIn) {
            nextStepContent = (
                <div className="ev-next-step">
                    <div className="ev-next-step-label">
                        <Icon name="check circle" /> You&apos;re all set
                    </div>
                    {isMobile
                        ? 'Your desktop session is now active. Return to your desktop or laptop to continue.'
                        : 'Your session is now active. You can close this tab and return to the application.'}
                </div>
            );
        } else if (showLoginFallback) {
            nextStepContent = (
                <Button className="button-submit ff_sb" onClick={this.goToLogin}>
                    Go to Login
                </Button>
            );
        } else {
            nextStepContent = (
                <div className="ev-next-step">
                    <div className="ev-next-step-label">
                        <Icon name="desktop" /> Next Step
                    </div>
                    {isMobile
                        ? <span>Your desktop session is being activated. Return to your <strong>desktop or laptop</strong> to continue.</span>
                        : 'Your session is being activated - please wait.'}
                </div>
            );
        }

        let heading = '';
        let description = null;
        let body = null;

        if (verificationStatus === 'success') {
            heading = 'Email Verified Successfully';
            description = 'Welcome to Aspenify! Your account is now active and ready to use.';
            body = nextStepContent;
        } else if (verificationStatus === 'alreadyVerified') {
            heading = 'Email Already Verified';
            description = "Your email address has already been verified - you're good to go.";
            body = (
                <Button className="button-submit ff_sb" onClick={this.goToLogin}>
                    Back to Log In
                </Button>
            );
        } else if (verificationStatus === 'error') {
            heading = 'Email Verification Failed';
            description = "We weren't able to verify your email address. This link may be invalid or has already been used. Update your password to try again.";
            body = (
                <React.Fragment>
                    <a href="#" onClick={this.goToUpdatePassword} className="ev-update-password-link">
                        Go to Update your Password
                    </a>
                    <div className="ev-next-step ev-next-step--error">
                        <div className="ev-next-step-label">
                            <Icon name="lock" /> Need Help?
                        </div>
                        Reach out to us at <a href="mailto:support@aspenify.com">support@aspenify.com</a> and our team will sort it out for you.
                    </div>
                </React.Fragment>
            );
        }

        return (
            <div className="login-main" style={{ height: '100%' }}>
                <LoadingComponent active={loading} message="We are verifying your email address." />
                <div className="ev-mobile-header">
                    <ModalHeader header={<img src={fullLogo} alt="Aspenify" />} />
                </div>
                <div className="left-section">
                    <div className='centered' style={{ justifyContent: "flex-start", paddingTop: "80px" }}>
                        <h2 className="f_24 ff_b float-left" style={{ color: "#707070", fontWeight: "normal", display: "flex", alignItems: "center", gap: "8px", paddingLeft: "10px" }}>
                            <a href="#" onClick={this.goToLogin} id="backLink" style={{
                                display: "flex", alignItems: "center", justifyContent: "center",
                                width: "28px", height: "28px",
                                border: "1px solid #d4d4d4", borderRadius: "6px",
                                color: "#707070", textDecoration: "none"
                            }}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="15 18 9 12 15 6"></polyline>
                                </svg>
                            </a>
                            {heading}
                        </h2>
                        <div style={{ paddingLeft: "10px" }}>
                            <p style={{ fontSize: "13px", fontWeight: "500", color: "#707070", marginBottom: "16px" }}>
                                {description}
                            </p>
                            {body}
                        </div>
                    </div>
                    <div className="f_8 mar_0 bottom" style={{ height: "46px", padding: "5px 10px", width: "100%" }}>
                        <div className="float-left">
                            Copyright &#169; {new Date().getFullYear()} Aspenify <br />Version {version ? version : ""}
                        </div>
                        <div className="float-right text-right">
                            Visit us at <br />
                            <a href="https://www.aspenify.com" rel="noopener noreferrer" style={{ color: "#6b6b6b" }} target="_blank" > www.aspenify.com </a>
                        </div>
                    </div>
                </div>

                <div className="right-section ev-right-section display-flex " style={{ flexDirection: 'column' }}>
                    <div className='login-right-div '>
                        <div>
                            <ModalHeader
                                header={<a href="https://aspenify.com" target="_blank" rel="noopener noreferrer"><img src={`${logo}`} alt="Logo" style={{ width: '40vw', height: 'auto', cursor: 'pointer' }} /></a>}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loading: state.loading.effects.registerAccount.verifyEmail,
        verificationStatus: state.registerAccount.emailVerificationStatus,
        version: state.login.version,
    };
}

const connectedEmailVerified = connect(mapStateToProps)(EmailVerified);
export { connectedEmailVerified as EmailVerified };
